import SubmitResponseType from '../../SubmitResponseType';
import ExternalHpaRedirectResponseHandler from './ExternalHpaRedirectResponseHandler';
import ErrorResponseHandler from './ErrorResponseHandler';
import ClientRedirectResponseHandler from './ClientRedirectResponseHandler';
import ResetSessionResponseHandler from './ResetSessionResponseHandler';
import FollowUrlResponseHandler from './FollowUrlResponseHandler';
import AdditionalActionResponseHandler from './AdditionalActionResponseHandler';
import FormValidationErrorResponseHandler from './FormValidationErrorResponseHandler';
import { ResponseHandlerResult, SubmitResponse } from '../../types';
import type FormHandler from '../../../forms/FormHandler';
import IPaymentProvider from '../../../payment/IPaymentProvider';

class ResponseHandlerRetriever {
  constructor(private paymentProvider: IPaymentProvider | undefined, private formHandler: FormHandler) { }

  get({ type }: SubmitResponse) : { handle: (...args: any) => Promise<ResponseHandlerResult> } {
    switch (type) {
      case SubmitResponseType.ExternalHpaRedirectResponse:
        return ExternalHpaRedirectResponseHandler;

      case SubmitResponseType.Error:
        return ErrorResponseHandler;

      case SubmitResponseType.ClientRedirect:
        return ClientRedirectResponseHandler;

      case SubmitResponseType.ResetSession:
        return ResetSessionResponseHandler;

      case SubmitResponseType.AdditionalAction:
        return AdditionalActionResponseHandler(this.paymentProvider);

      case SubmitResponseType.FollowUrl:
        return FollowUrlResponseHandler(this);

      case SubmitResponseType.FormValidationError:
        return FormValidationErrorResponseHandler(this.formHandler);

      default:
        throw new Error();
    }
  }
}

export default ResponseHandlerRetriever;
